import { render } from "./genome_browser_page.vue?vue&type=template&id=96b70a0a"
import script from "./genome_browser_page.vue?vue&type=script&lang=js"
export * from "./genome_browser_page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__